import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';

import { goFullScreen } from '../../util/go_full_screen';

const EntriesHeader = ({ theme }) => {
  return (
    <Box>
      <ImageTitleBox>
        {theme.logo ? <Image onClick={goFullScreen} src={theme.logo} /> : null}
      </ImageTitleBox>
    </Box>
  );
};

const Box = styled.div`
  label: entries-header-box;

  display: grid;

  text-align: center;

  align-items: center;
  justify-content: center;

  background-color: ${props => props.theme.foregroundColor};
  color: ${props => props.theme.foregroundTextColor};

  height: 115px;
  width: 100%;

  margin-bottom: 0.7em;

  box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.1);
`;

const ImageTitleBox = styled.div`
  display: grid;
  grid-template-columns: auto auto;
`;

const Image = styled.img`
  max-height: 4em;
  margin-right: 0.5em;
`;

// const Title = styled.h1`
//   font-size: 2em;
//   font-weight: 600;

//   margin-top: 0.4em;
//   margin-bottom: 0.3em;
// `;

export default withTheme(EntriesHeader);
